import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

/**
 * 404 Not Found — premium empty state with ambient depth,
 * subtle medical motif, and editorial typography.
 */
export function NotFoundPage(): JSX.Element {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden gradient-bg px-4">
      <div className="relative animate-fade-in text-center">
        {/* Large mono 404 */}
        <p className="font-mono text-[120px] font-black leading-none text-slate-200/80">
          404
        </p>

        {/* Gradient divider */}
        <div className="divider-gradient mx-auto my-6 w-40" />

        {/* Medical icon */}
        <div className="relative mx-auto mb-5">
          <div className="absolute inset-0 mx-auto h-14 w-14 rounded-2xl bg-teal-100/30 animate-breathe" />
          <div className="relative mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-teal-50 to-teal-100/60 ring-1 ring-teal-200/50 shadow-sm">
            <svg className="h-6 w-6 text-teal-500" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
            </svg>
          </div>
        </div>

        <h1 className="page-title-serif text-[1.75rem]">
          Page not found
        </h1>
        <p className="mx-auto mt-3 max-w-[320px] text-[13px] leading-relaxed text-slate-500">
          The page you&rsquo;re looking for doesn&rsquo;t exist or has been moved.
          Try navigating back to the dashboard.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link to="/visits">
            <Button variant="primary" size="md">
              <svg className="mr-1.5 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
              </svg>
              Back to Visits
            </Button>
          </Link>
        </div>

        {/* Compliance footer */}
        <p className="mt-12 text-[9px] font-semibold uppercase tracking-[0.15em] text-slate-400">
          AssistMD &middot; Clinical Intelligence
        </p>
      </div>
    </div>
  );
}
